import { useEffect, useRef } from "react";
import Lenis from "lenis";
import usePrefersReducedMotion from "@/hooks/usePrefersReducedMotion";

export default function LenisProvider({ children }) {
  const lenisRef = useRef(null);
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (reduced) return; // respect user preference — native scrolling
    const lenis = new Lenis({
      duration: 1.35,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.4,
    });
    lenisRef.current = lenis;
    document.body.classList.add("lenis-loaded");

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      document.body.classList.remove("lenis-loaded");
    };
  }, [reduced]);

  return children;
}
